<script>
import InfoPedido from '@/components/catalogo-produtos/InfoPedido.vue';
import SLSItemService from '@/services/SistemaDKP/SLSItem.service';
import SlsEmbalagService from '@/services/SistemaDKP/sls-embalag.service';
import Swal from 'sweetalert2';
import { mapActions, mapGetters } from 'vuex';
import {
  BBadge, BButton, BCardText, BCol, BFormGroup, BImg, BLink, BModal, BRow,
} from 'bootstrap-vue';
import axios from 'axios';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { getTotvsBaseUrl } from '@/utils/totvsApi';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';

const slsItemService = new SLSItemService();
const slsEmbalagemService = new SlsEmbalagService();
export default {
  name: 'ModalPromocaoSelected',
  components: {
    BLink,
    BButton,
    BCol,
    BFormGroup,
    BImg,
    BRow,
    BBadge,
    BCardText,
    BModal,
    InfoPedido,
  },
  data() {
    return {
      imagemPadrao: IMAGEM_PADRAO,
      selected: null,
      show: false,
      gradeAtual: [],
      arrayEmbalagens: [],
      itemsCarrinho: [],
      showWarning: false,
      impostoLoading: false,
      impostoCalculado: null,
    };
  },

  computed: {
    ...mapGetters('InfoPedido', {
      item: 'GET_ITEM_PROMOCAO_SELECTED',
    }),
    ...mapGetters('InfoPedido', [
      'GET_CLIENTE_DATA',
      'GET_ENDERECO_ENTREGA',
      'GET_DATA_CAPA_PEDIDO',
    ]),
    ...mapGetters('PedidosStore', {
      pedidoItens: 'getItemPedido',
    }),

  },
  methods: {
    async onSelectedEmbalagem() {
      console.log('chamei onSelectedEmbalagem');
      const embalagensValues = this.$store.getters['slsEmbalagem/getEsEmbalg'];

      const itemSelected = this.$store.getters['InfoPedido/GET_ITEM_SELECTED'];
      const cliente = this.$store.getters['InfoPedido/GET_CLIENT_ID_ERP'];
      console.log('CLIENTE', cliente);

      const itemImagem = {
        codMarca: itemSelected.cod_marca,
        codCateg: itemSelected.cod_categ,
        tabelaprecoId: this.$store.getters['InfoPedido/GET_TABELE_PRECO_FORM'].tabelapreco_id,
        clienteIderp: cliente.clienteiderp,
        familiaComercialId: itemSelected.familia_comercial_id,
      };
      console.log('embalagensValues', embalagensValues);
      await this.itensdetalhes(itemImagem);
      const newGradeAtual = {
        embalagens: [

        ],
      };
      this.gradeAtual = [];
      console.log(
        'itemSelected.cod_marca', itemSelected,
      );
      for (const embalagemValue of embalagensValues) {
        console.log(
          'itemSelected.cod_marca', itemSelected,
        );
        console.log(itemSelected.cod_marca && itemSelected.cod_categ && this.$store.getters['InfoPedido/GET_TABELE_PRECO_FORM'].tabelapreco_id && itemSelected.familia_comercial_id);
        if (itemSelected.cod_marca && itemSelected.cod_categ && this.$store.getters['InfoPedido/GET_TABELE_PRECO_FORM'].tabelapreco_id && itemSelected.familia_comercial_id) {
          console.log(
            'entrou no if',
          );
          const item = {
            codMarca: itemSelected.cod_marca,
            codCateg: itemSelected.cod_categ,
            tabelaprecoId: this.$store.getters['InfoPedido/GET_TABELE_PRECO_FORM'].tabelapreco_id,
            clienteIderp: cliente.clienteiderp,
            familiaComercialId: itemSelected.familia_comercial_id,
            cdnEmbalagem: embalagemValue.cdn_embalagem,
            codEmbal: embalagemValue.cdn_embalagem,
          };
          try {
            const baseUrl = await getTotvsBaseUrl();
            const url = `${baseUrl}/grade/${item.familiaComercialId}/${item.codEmbal}/${item.clienteIderp}/${this.$store.getters['InfoPedido/GET_TABELE_PRECO_FORM'].tabelapreco_id}`;
            const response = await fetch(url);

            if (!response.ok) {
              throw new Error(`Erro na solicitação: ${response.statusText}`);
            }

            const data = await response.json();

            newGradeAtual.embalagens.push({
              descricao_embalagem: embalagemValue.des_embalag,
              cdn_embalagem: embalagemValue.cdn_embalagem,
              grade: data,
            });
          } catch (error) {
            console.error('Erro ao fazer a solicitação:', error);
          }
        }
        this.gradeAtual.push(
          newGradeAtual,
        );

        console.log('GRADE ATUAL', this.gradeAtual);
      }

      this.$store.commit('ItemStore/SET_CURRENT_ITEM', this.getInfoItem.dataItensPedido);

      // this.$refs.refModalTopSelectedEmbalagens.hide()
      // this.$bvModal.show('modal-info-produto-id')
      this.selected = null;
    },
    verificarQuantidade() {
      if (this.item.quantidade > this.item.picitemquantidade) {
        this.item.quantidade = this.item.picitemquantidade;
        this.showWarning = true;
      } else if (this.item.quantidade < 0) {
        this.item.quantidade = 0;
        this.showWarning = false;
      } else {
        this.item.quantidade = this.item.quantidade;
        this.showWarning = false;
      }
    },
    formatPrice(value) {
      const numero = Number(value);
      const valueFixed = numero.toFixed(2);
      return valueFixed.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
    async calcularImposto(newItem) {
      const baseUrl = await getTotvsBaseUrl();
      const url = `${baseUrl}/simular-Impostos-novo-metodo`;
      const data = {
        ttCabPedido: [
          {
            'c-pr-cod-estabel': this.GET_CLIENTE_DATA.estabelecimento.estabelecimentoid,
            'c-pr-nome-abrev': this.GET_CLIENTE_DATA.cliente.clientenomeabreviado,
            'c-pr-nat-operacao': this.GET_CLIENTE_DATA.naturezaOperacao?.naturezaoperacaoid || '6101',
            'c-pr-cod-canal-venda': this.GET_CLIENTE_DATA.canalVenda?.canal_venda_id || '',
            'c-pr-it-codigo': newItem.item_id,
            'd-pr-quantidade': Number(this.item.quantidade),
            'd-pr-vl-preori-ped': Number(this.item.item_price),
            'd-pr-per-des-item': Number(this.item.porcentagem_desconto),
            'p-simulacao': 0,
            'p-uf-ds': this.GET_CLIENTE_DATA.enderecoEntrega.ufid,
            'p-cidade-ds': this.GET_CLIENTE_DATA.enderecoEntrega.clienteenderecocidade,
            'p-contr-icms': this.GET_DATA_CAPA_PEDIDO.clienteisentoie ? 1 : 0,
            'p-tp-frete': 0,
            'p-tp-tabpre': this.GET_DATA_CAPA_PEDIDO.tabelaprecoid,
            'p-cod-cond-pagto': this.GET_DATA_CAPA_PEDIDO.condicaopagamentoid,
            ttitempedido: [{
              itCodigo: newItem.item_id,
            }],
          },
        ],
      };

      try {
        this.impostoLoading = true;
        const response = await axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.data.ttRetornoImposto && response.data.ttRetornoImposto[0]) {
          const precoImposto = response.data.ttRetornoImposto[0]['d-pr-unitario'] || 0;
          const valorBaseIcms = response.data.ttRetornoImposto[0]['d-pr-base-icms'] || 0;
          const valorIcms = response.data.ttRetornoImposto[0]['d-pr-valor-icms'] || 0;
          const naturezaoperacaoidimposto = response.data.ttRetornoImposto[0]['c-pr-nat-operacao'] || 0;

          return {
            precoComImposto: precoImposto,
            baseIcms: valorBaseIcms,
            valorIcms,
            naturezaoperacaoidimposto,
          };
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Imposto calculado!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });

        return null;
      } catch (error) {
        console.error('Erro ao fazer a chamada à API:', error);
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao calcular impostos',
          timer: 2000,
        });
        return null;
      } finally {
        this.impostoLoading = false;
      }
    },
    async adicionarCarrinho() {
      const itemSelecionado = {
        index: this.pedidoItens.length + 1,
        cod_marca: this.item.cod_marca,
        familia_comercial_id: this.item.referencia,
        familia_comercial_descricao: this.item.item_descricao,
        cdn_cor: this.item.cdn_cor,
        cdn_tamanho: this.item.cdn_tamanho,
        des_tamanho: this.item.des_tamanho,
        des_cor: this.item.des_cor,
        item_id: this.item.itemid,
        item_descricao: `${this.item.referencia} - ${this.item.item_descricao}`,
        item_imagem: this.item.item_img_principal,
        pedido_item_seq: this.$store.getters['PedidosStore/getLastSequenceItemPedido'] + 10,
        picid: this.item.picid,
        marca: this.item.des_marca,
        embalagem: this.item.des_embalag,
        cdn_embalag: this.item.cdn_embalagem,
        pedido_item_preco_unitario: parseFloat(this.item.item_price),
        pedido_item_quantidade: parseInt(this.item.quantidade, 10),
        valor_total: +this.item.item_price * parseFloat(this.item.quantidade),
      };

      const impostos = await this.calcularImposto({
        item_id: itemSelecionado.item_id,
        precoUnitario: this.item.item_price,
        valor: this.item.quantidade,
      });

      if (impostos === null) {
        return;
      }

      const { precoComImposto } = impostos;
      const { baseIcms } = impostos;
      const { valorIcms } = impostos;
      const { naturezaoperacaoidimposto } = impostos;

      itemSelecionado.precoComImposto = precoComImposto;
      itemSelecionado.baseIcms = baseIcms;
      itemSelecionado.valorIcms = valorIcms;
      itemSelecionado.naturezaoperacaoidimposto = naturezaoperacaoidimposto;
      itemSelecionado.cliente = this.GET_CLIENTE_DATA.cliente.clientenomeabreviado;
      itemSelecionado.picitemquantidade = this.item.picitemquantidade;

      console.log('itemSelecionado', itemSelecionado);
      this.itemsCarrinho.push(itemSelecionado);
      const itemQtd = this.itemsCarrinho.filter((item) => item.pedido_item_quantidade > 0);
      for (const item of itemQtd) {
        this.$store.commit('PedidosStore/ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO', item);
      }
      this.$store.commit('ECommercerStore/ADD_OR_UPDATE_PRODUCT_TO_CART', {
        ...this.item,
        item_price: parseFloat(this.item.item_price),
        quantidade: 1,
      });
      this.$bvModal.hide('modal-promocao-selected');
    },
    onCancelModal() {
      this.mainImg = IMAGEM_PADRAO;
      this.$bvModal.hide('modal-promocao-selected');
    },
  },
};
</script>

<template>
  <b-modal id="modal-promocao-selected" title="Adicionar Item em Promoção ao Pedido" size="xl" ref="refModalPromocao"
    ok-only no-close-on-esc no-close-on-backdrop ok-title="Confirma" hide-footer @ok="onSelectedEmbalagem">
    <b-overlay :show="impostoLoading" rounded="sm">
      <template #overlay>
        <div v-if="impostoLoading" class="text-center">
          <strong>Calculando impostos...</strong>
          <b-spinner small class="ml-1"></b-spinner>
        </div>
      </template>
      <b-row class="my-2" v-if="item">
        <b-col cols="12" sm="12" md="4" class="px-auto mt-1">
          <b-img
            :src="item.item_img_principal ? item.item_img_principal : imagemPadrao"
            :alt="`${item.item_name}-${item.item_id}`" style="min-height: 350px;padding: 0;" class="img-fluid" />
        </b-col>

        <b-col cols="12" md="7">
          <h4>{{ item.referencia }} - {{ item.item_descricao }}</h4>
          <b-card-text class="item-company mb-0">
            <span>by </span>
            <b-link class="company-name">{{ item.des_marca }}</b-link>
          </b-card-text>
          <div class="ecommerce-details-item_price d-flex flex-wrap mt-1">
            <h4 class="item-item_price mr-1">
              R$ {{ formatPrice(item.item_price) }} -
              <span style="text-decoration: line-through; color: red;">
                R$ {{ (item.item_price / (1 - item.porcentagem_desconto / 100)).toFixed(2) }}
              </span>
            </h4>
          </div>

          <b-card-text>Disponível - <span class="text-success">Em estoque</span> - {{ item.picitemquantidadesaldo }}
            unidades</b-card-text>
          <b-card-text>{{ item.item_caracteristicas }}</b-card-text>

          <div class="item-color-options">
            <h6>Embalagem</h6>
            <ul class="list-unstyled mb-0" style="
    display: flex;
    gap: 20px;
">
              <li style="display: flex;gap: 10px">
                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="item.des_embalag === item.des_embalag ? 'secondary' : 'outline-secondary'" size="sm">
                  {{ item.des_embalag }}
                </b-button>
              </li>
            </ul>
          </div>

          <hr>

          <div class="item-color-options">
            <h6>Cores</h6>
            <ul class="list-unstyled mb-0" style="
    display: flex;
    gap: 20px;
">
              <li style="display: flex;gap: 10px">
                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="item.des_cor === item.des_cor ? 'secondary' : 'outline-secondary'" size="sm">
                  {{ item.des_cor }}
                </b-button>
              </li>
            </ul>
          </div>
          <!-- Sizes -->
          <hr>
          <div class="item-color-options">
            <h6>Tamanhos</h6>
            <ul class="list-unstyled mb-0" style="
    display: flex;
    gap: 20px;
">
              <li style="display: flex;gap: 10px">
                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="item.des_tamanho === item.des_tamanho ? 'secondary' : 'outline-secondary'" size="sm">
                  {{ item.des_tamanho }}
                </b-button>
              </li>
            </ul>
          </div>

          <!-- Quantity -->
          <hr>
          <div class="item-color-options" style="position:relative;">
            <h6>Quantidade</h6>
            <b-form-group>
              <b-form-input v-model="item.quantidade" type="number" style="width: 130px"
                @blur="verificarQuantidade()" />
              <span v-if="showWarning" class="text-danger">
                A quantidade não pode ser maior que {{ item.picitemquantidade }}.
              </span>
            </b-form-group>
          </div>

          <!-- Selected Items -->
          <hr>
          <!--        <div class="mx-1">-->
          <!--          <div><h3>Itens Adicionados</h3></div>-->
          <!--          <div class="row mt-3" style="gap: 10px">-->

          <!--            <div class="col-auto cursor-pointer px-0" v-for="(item, index) in items" :id="item.item_id" :key="item.item_id">-->
          <!--              <b-badge variant="primary" class="d-flex align-items-center">-->
          <!--                <span>{{ item.embalagem }} - {{ item.valor }} - {{ item.des_cor }} - {{ item.tamanho }}</span>-->
          <!--                <button type="button" class="close ml-2" @click="removeItem(index,item)">-->
          <!--                  <span aria-hidden="true">&times;</span>-->
          <!--                </button>-->
          <!--              </b-badge>-->
          <!--            </div>-->

          <!--          </div>-->
          <!--        </div>-->

        </b-col>
      </b-row>

      <div style="display: flex; justify-content: end ;gap: 10px">
        <div>
          <b-button variant="danger" @click="onCancelModal">
            <feather-icon icon="XIcon" class="mr-50" />
            Cancelar
          </b-button>
        </div>
        <div>
          <b-button variant="success" @click="adicionarCarrinho(item)" :disabled="showWarning || this.item.quantidade === 0">
            <feather-icon icon="ShoppingCartIcon" class="mr-50" />
            Adicionar
          </b-button>
        </div>
      </div>
    </b-overlay>
  </b-modal>

</template>

<style scoped lang="scss"></style>
